import type { ReactNode } from 'react';
import { useCan } from '../../hooks/usePermission.js';

/**
 * Renders `children` only when the signed-in person holds the permission — or,
 * given a list, at least one of them. The permission twin of `RoleGate`, which
 * asks "what kind of user is this?" where this asks "what may this user do?".
 */
export function PermissionGate({
  permission,
  children,
  fallback = null,
}: {
  permission: string | readonly string[];
  children: ReactNode;
  fallback?: ReactNode;
}): JSX.Element {
  const keys = Array.isArray(permission) ? permission : [permission];
  const allowed = useCan(...keys);
  return <>{allowed ? children : fallback}</>;
}
